import type { ColDef } from "ag-grid-enterprise";
import type { TimePeriodColumnOptions } from "../columnFactory";
import { baseTimePeriodProperties } from "./baseTimePeriodProperties";
import { getEditableByPlanBy } from "./editableByPlanBy";

/**
 * Creates the single Period-To-Go column definition.
 */
export function createPTGColumns(options: TimePeriodColumnOptions): ColDef[] {
  const {
    planBy,
    planningYear,
    metaData,
    intake,
    editableProducer,
    editableRowPredicate,
    editableMetricsOverride,
    editableTimeWindowPredicate,
    cubeWindow
  } = options;
  const base = baseTimePeriodProperties(
    planBy,
    planningYear,
    metaData,
    cubeWindow,
    editableTimeWindowPredicate !== undefined
  );
  const editable =
    planBy === "SH%"
      ? false
      : getEditableByPlanBy({
          planBy,
          planningYear,
          metaData,
          intake,
          editableProducer,
          editableRowPredicate,
          editableMetricsOverride,
          editableTimeWindowPredicate,
          cubeWindow
        });

  return [
    {
      ...base,
      field: "PTG",
      headerName: metaData.gregMapping["PTG"] ?? "PTG",
      headerTooltip: "PTG",
      editable
    }
  ];
}
